<template>
<v-toolbar-items class="d-flex align-center justify-center">
  <v-combobox
    v-show="!hideSearch"
    class="wgu-geocoder-combo wgu-solo-field"
    outlined
    dense
    color="accent"
    :dark="isPrimaryDark"
    filled
    return-object
    hide-details
    :no-filter="noFilter"
    v-model="selected"
    :autofocus="autofocus"
    :items="resultItems"
    :label="$t('wgu-geocoder.placeHolder')"
    :clearable="clearable"
    @click:clear="this.searchResultsCleared"
    :persistent-hint="persistentHint"
    :hidden="hideSearch"
    :__rounded="rounded"
    :search-input.sync="search"
  ></v-combobox>
  <!-- geomer BHU: disabled rounded, added click clear event-->

  <div>

    <!-- geomer BHU disabled
    <v-btn @click='toggle()'
      color="onprimary"
      icon
      :title="$t('wgu-geocoder.title')">
      <v-icon medium>{{icon}}</v-icon>
    </v-btn>
    -->

  </div>
</v-toolbar-items>
</template>

<script>
import { Mapable } from '../../mixins/Mapable';
import { ColorTheme } from '../../mixins/ColorTheme';
import { GeocoderController } from './GeocoderController';
import { fromLonLat, transformExtent } from 'ol/proj';
import ViewAnimationUtil from '../../util/ViewAnimation';
import { WguEventBus } from '../../WguEventBus'

// geomer BHU OpenLayers Imports
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
// import CircleStyle from 'ol/style/Circle.js';
// import Fill from 'ol/style/Fill.js';
import Icon from 'ol/style/Icon.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';
import WFS from 'ol/format/WFS.js';
import GeoJSON from 'ol/format/GeoJSON';
// import WFS from '../../../node_modules/ol/format/WFS.js';

export default {
  name: 'wgu-geocoder-input',
  mixins: [Mapable, ColorTheme],
  props: {
    icon: { type: String, required: false, default: 'search' },
    rounded: { type: Boolean, required: false, default: true },
    autofocus: { type: Boolean, required: false, default: true },
    clearable: { type: Boolean, required: false, default: true },
    persistentHint: { type: Boolean, required: false, default: true },
    debug: { type: Boolean, required: false, default: false },
    minChars: { type: Number, required: false, default: 3 },
    queryDelay: { type: Number, required: false, default: 300 },
    provider: { type: String, required: false, default: 'osm' },
    providerOptions: { type: Object, required: false, default: function () { return {}; } },
    suggesterURL: { type: String, required: true, default: '/geocoder/api/v1/suggest' }, /* geomer BHU */
    selectorURL: { type: String, required: true, default: '/geocoder/api/v1/select' } /* geomer BHU */

  },
  data () {
    return {
      results: [],
      lastQueryStr: '',
      noFilter: true,
      search: null,
      selecting: false,
      selected: null,
      hideSearch: false,
      timeout: null,
      mapVectorLayer: null, /* geomer BHU Layer stores search address marker */
      mapMarkerFeature: null, /* geomer BHU */
      mapStreetMarkerLayer: null /* geomer BHU Layer stores highlighted street search result */
    }
  },
  computed: {
    resultItems () {
      const items = [];
      if (!this.results) {
        return items;
      }
      this.trace(`computed.resultItems() - cur results len=${this.results.length}`);

      // Convert results to v-combobox (text, value) Items
      this.results.forEach(result => {
        this.trace(`add to this.items: ${result.address.name}`);
        items.push({ text: result.address.name.replace('Köln, ', ''), value: result }); /* geomer BHU: remove city name in result display */
      });

      return items;
    }
  },
  methods: {
    trace (str) {
      this.debug && console && console.info(str);
    },
    toggle () {
      // Show/hide search combobox
      this.hideSearch = !this.hideSearch;
    },
    searchResultsCleared () {
      /* geomer BHU: Clear search result, inform other modules */
      WguEventBus.$emit('wrcLink_update_Building', -99);
      WguEventBus.$emit('button3d_update_Address', [null, null, null]);

      this.removeSearchResultsMarkers();
    },
    removeSearchResultsMarkers () {
      /* geomer BHU: remove address marker and highlighted street */
      try {
        this.mapVectorLayer.getSource().clear();
        this.mapStreetMarkerLayer.getSource().clear();
      } catch (error) {
        console.log('Could not clear address markers')
      }
    },
    // Query by string - should return list of selection items (adresses) for ComboBox
    querySelections (queryStr) {
      this.timeout = setTimeout(() => {
        // Let Geocoder Provider do the query
        // items (item.text fields) will be shown in combobox dropdown suggestions
        this.trace(`geocoderController.query: ${queryStr}`);
        this.geocoderController.query(queryStr)
          .then(results => this.onQueryResults(results))
          .catch(err => this.onQueryError(err))
      }, this.queryDelay);
    },
    onQueryResults (results) {
      // Handle query results from GeocoderController
      this.timeout && clearTimeout(this.timeout);
      this.timeout = null;
      this.results = null;

      if (!results || results.length === 0) {
        return;
      }

      // ASSERT: results is defined and at least one result
      this.trace(`results ok: len=${results.length}`);
      this.results = results;
    },
    onQueryError (err) {
      if (err) {
        this.trace(`onQueryResult error: ${err}`);
      }
    },
    onMapBound () {
    /* geomer BHU: on map init, create marker layers to highlight address search result and street search result */

      /*

      const whiteRingStyle = new Style({
        image: new CircleStyle({
          radius: 24,
          // fill: new Fill({color: 'black'}),
          stroke: new Stroke({
            color: 'white',
            width: 3
          })
        })
      });

      const blueRingStyle = new Style({
        image: new CircleStyle({
          radius: 24,
          // fill: new Fill({ color: 'black' }),
          stroke: new Stroke({
            color: '#007bC7',
            width: 3
          })
        })
      });

      */

      const imageStyle = new Style({
        image: new Icon({
          anchor: [0.5, 0.5],
          src: 'static/images/marker_blau.png'
        })
      });

      this.mapVectorLayer = new VectorLayer({
        source: new VectorSource({
          features: []
        }),
        style: imageStyle
      });

      this.map.addLayer(this.mapVectorLayer);

      const pinkStyle = new Style({
        stroke: new Stroke({
          width: 12,
          color: [206, 35, 157, 0.4]
        })
      });

      this.mapStreetMarkerLayer = new VectorLayer({
        source: new VectorSource({
          features: []
        }),
        style: pinkStyle
      });

      this.map.addLayer(this.mapStreetMarkerLayer);
    }
  },
  watch: {
    // Input string value changed
    search (queryStr) {
      if (this.timeout || this.selecting) {
        // Query or selection in progress
        this.trace('query or selection in progress...');
        return;
      }
      if (!queryStr || queryStr.length === 0) {
        // Query reset
        this.trace('queryStr none');
        this.results = null;
        return
      }

      // ASSERTION: queryStr is valid
      queryStr = queryStr.trim();

      // Only query if minimal number chars typed and querystring has changed
      queryStr.length >= this.minChars && queryStr !== this.lastQueryStr && this.querySelections(queryStr);
      this.lastQueryStr = queryStr;
    },
    // User has selected entry from suggested items
    async selected (item) { /* geomer BHU: set to async */
      if (!item || !Object.prototype.hasOwnProperty.call(item, 'text') || !Object.prototype.hasOwnProperty.call(item, 'value')) {
        return;
      }
      this.selecting = true;
      this.trace(`selected=${item.text}`);

      // Position Map on result
      const result = item.value;
      const mapProjection = this.map.getView().getProjection();

      /* geomer BHU */
      if (this.provider === 'solr') {
        const handledResult = await this.geocoderController.handleSolr(item.value.id);
        result.lon = handledResult.coords.split(',')[1];
        result.lat = handledResult.coords.split(',')[0];
        result.buildingId = handledResult.buildingId;
        result.streetName = handledResult.streetName;
        result.houseNumber = handledResult.houseNumber
      }
      const coords = fromLonLat([result.lon, result.lat], mapProjection);

      // geomerBHU: inform WRCLink Button and 3D Window of found address
      WguEventBus.$emit('wrcLink_update_Building', result.buildingId);
      WguEventBus.$emit('button3d_update_Address', [result.address.name.replace('Köln, ', ''), result.lon, result.lat]);

      // geomer BHU: Mark result coordinate in map
      if (result.houseNumber !== '-1' && this.mapVectorLayer) {
        this.removeSearchResultsMarkers();

        const addressMarker = new Feature({
          type: 'icon',
          geometry: new Point([coords[0], coords[1]])
        });

        this.mapVectorLayer.getSource().addFeature(addressMarker)
      }

      if (result.houseNumber === '-1' && this.mapStreetMarkerLayer && this.$appConfig.modules['wgu-geocoder'].geoserver) {
        //* geomer BHU
        // Mark street
        // TODO Zoom auf BBOX? Oder sollte das nicht schon Solr machen?
        // TODO nur bei Mittelpunktssuche anzeigbar?

        // Send Request to geoserver to highlight found streetname

        const me = this;

        this.removeSearchResultsMarkers();

        const featureRequest = new WFS().writeGetFeature({
          srsName: 'EPSG:3857',
          featureTypes: ['postgis:fvl_streetfilter_byname'],
          outputFormat: 'application/json',
          viewParams: 'sn:' + result.streetName.replace(/[^\w\s\-.,äöüß]/gi, '') // Umlaut wird von geoserver ncht akzeptiert. RegExp?
        });

        const addedMarker = fetch(this.$appConfig.modules['wgu-geocoder'].geoserver, {
          method: 'POST',
          body: new XMLSerializer().serializeToString(featureRequest)
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            const features = new GeoJSON().readFeatures(json);
            // console.log(features);
            if (features.length > 0) {
              me.mapStreetMarkerLayer.getSource().addFeatures(features);
              me.map.getView().fit(me.mapStreetMarkerLayer.getSource().getExtent());
            }
          });

        if (!addedMarker) {
          console.log('Error while request sreet highliting');
        }
      }

      // Prefer zooming to bounding box if present in result
      if (Object.prototype.hasOwnProperty.call(result, 'boundingbox')) {
        // Result with bounding box.
        // bbox is in EPSG:4326, needs to be transformed to Map Projection (e.g. EPSG:3758)
        // const extent = transformExtent(result.boundingbox, 'EPSG:4326', 'EPSG:3857');
        const extent = transformExtent(result.boundingbox, 'EPSG:4326', mapProjection); // geomer BHU

        ViewAnimationUtil.to(this.map.getView(), extent, '');
      } else {
        // No bbox in result: center on lon/lat from result and zoom in
        ViewAnimationUtil.to(this.map.getView(), coords, ''); // geomer BHU
      }
      this.selecting = false;
    }
  },
  mounted () {
    // Setup GeocoderController to which we delegate Provider and query-handling
    this.geocoderController = new GeocoderController(this.provider, this.providerOptions, this);
  }
}
</script>
